import { Facebook } from "@/assets/icons/share icons/Facebook";
import { WhatsApp } from "@/assets/icons/share icons/WhatsApp";
import { LinkedIn } from "@/assets/icons/share icons/LinkedIn";
import { Xicon } from "@/assets/icons/share icons/Xicon";
import { toast } from "react-toastify";
import { cn } from "@/lib/utils";
import { Copy } from "@/assets/icons/share icons/Copy";
import { GiveBoost } from "@/assets/icons/share icons/GiveBoost";
import { Link } from "@tanstack/react-router";
import { ProgramType } from "@/types/programs";
import { useTranslation } from "react-i18next";

export const ShareContent = ({ program }: { program: ProgramType }) => {
  const { t } = useTranslation();

  const shareData = {
    url: `${window.location.origin}/?program=${program?.id}`,
  };
  const encodedURL = encodeURIComponent(shareData.url);

  return (
    <div className={cn("flex w-full  flex-col gap-6 p-4 text-[#232329]")}>
      <div className="flex gap-4">
        <GiveBoost />
        <div>
          <h3 className="mb-0.5 text-base font-650 leading-[140%]">{t("program.giveBoost")}</h3>
          <p className="text-sm font-350 leading-[140%]">{t("program.kindnessChain")}</p>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <Link
          to={`https://wa.me/?text=${encodedURL}`}
          className="rounded-full bg-[#E2DDD7] p-4 lg:p-6"
        >
          <WhatsApp />
        </Link>
        <Link
          className="rounded-full bg-[#E2DDD7] p-4 lg:p-6"
          to={`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`}
        >
          <Facebook />
        </Link>
        <Link
          className="rounded-full bg-[#E2DDD7] p-4 lg:p-6"
          to={`https://www.linkedin.com/sharing/share-offsite/?url=${encodedURL}`}
        >
          <LinkedIn />
        </Link>
        <Link
          to={`https://twitter.com/intent/tweet?url=${encodedURL}`}
          className="rounded-full bg-[#E2DDD7] p-4 lg:p-6"
        >
          <Xicon />
        </Link>
      </div>
      <div
        className={cn(
          "items-center min-h-[53px] flex flex-row sm:max-w-full max-w-[350px] justify-between w-full bg-[#E2DDD7] overflow-x-hidden",
        )}
      >
        <p className="flex h-full w-full items-center overflow-x-hidden truncate rounded-l rounded-r-none border-0 bg-[#E2DDD7] p-4 text-sm rtl:rounded-r">
          {shareData.url}
        </p>
        <button
          className="flex h-full items-center rounded-r bg-[#E2DDD7] p-4 hover:bg-[#F8F7F7] rtl:rounded-l"
          onClick={() => {
            navigator.clipboard.writeText(shareData.url);
            toast.success(t("circle.linkCopied"), {
              position: "top-center",
            });
          }}
          aria-label="Copy Program URL"
        >
          <Copy />
        </button>
      </div>
    </div>
  );
};
